<template>
  <h4 class="panel-title">
    <a
      :class="{'collapsed': collapsed}"
      :href="`#${contentContainer}`"
      role="button"
      data-toggle="collapse"
      :data-parent="`#${accordion}`"
    >
      <slot/>
    </a>
  </h4>
</template>

<script>
export default {
  name: "collapse-title",
  props: {
    contentContainer: {
      type: String,
      required: true
    },
    accordion: {
      type: String,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: true,
      required: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Collapse/CollapseTitle.vue